module.exports = __webpack_public_path__ + "img/anniversary-characters-gold.1fc77994.png";